module.exports = __webpack_public_path__ + "static/media/video_back.86e77b06.mp4";